// eslint-disable-line no-bitwise
import * as XLSX from 'xlsx';
import { jsPDF as JSpdf } from 'jspdf';
import moment from 'moment';
import logo from '../assets/images/kitegateway_icon_dark.png';

export const downloadReport = (data, type) => {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i += 1) {
      view[i] = s.charCodeAt(i) & 0xff; // eslint-disable-line no-bitwise
    }
    return buf;
  };
  const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Report_${type}_${moment().format('DD-MM-YYYY')}.xlsx`;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const downloadExcel = (data, columns, file, timezone) => {
  const header = [];
  columns.forEach((col) => {
    header.push(col.title);
  });
  const dataExtract = [header];

  data.forEach((item) => {
    const row = [];
    columns.forEach((col) => {
      if (col.dataIndex === 'created_at' || col.dataIndex === 'transaction_date') {
        row.push(moment(item[col.dataIndex]).utc().add('hours', timezone.offset).format('DD/MM/YYYY'));
      } else {
        row.push(item[col.dataIndex]);
      }
    });
    dataExtract.push(row);
  });
  const workb = XLSX.utils.book_new();
  workb.SheetNames.push('Sheet1');
  const wsData = dataExtract;
  const ws = XLSX.utils.aoa_to_sheet(wsData);
  workb.Sheets.Sheet1 = ws;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Responses');
  XLSX.writeFile(wb, `${file}.xlsx`);
};

export const downloadPDF = (data, columns, file, timezone) => {
  const time = moment(Date.now()).utc().add('hours', timezone.offset).format('DD-MM-YYYY');
  const doc = new JSpdf({ orientation: 'landscape' });
  doc.addImage(logo, 'PNG', 0, 0, 17, 17.06);
  doc.text(`${file} - ${time}`, 50, 10);
  const header = [];
  const dataExtract = [];

  columns.forEach((col) => {
    header.push(col.title);
  });

  data.forEach((item) => {
    const row = [];
    columns.forEach((col) => {
      if (col.dataIndex === 'created_at' || col.dataIndex === 'transaction_date') {
        row.push(moment(item[col.dataIndex]).utc().add('hours', timezone.offset).format('DD/MM/YYYY'));
      } else if (col.dataIndex === 'transaction_amount'
        || col.dataIndex === 'source_wallet_amount'
        || col.dataIndex === 'transfer_amount') {
        row.push(new Intl.NumberFormat().format(Math.round((item[col.dataIndex]) * 10000) / 10000));
      } else {
        row.push(item[col.dataIndex]);
      }
    });
    dataExtract.push(row);
  });
  doc.autoTable({
    margin: { top: 19, left: 1, right: 1 },
    head: [header],
    body: dataExtract,
    showHead: 'firstPage',
    startY: 25,
    // Default for all columns
    // styles: { cellWidth: 'wrap' },
    // styles: { overflow: 'hidden', cellWidth: 'wrap' },
    styles: { cellWidth: 'wrap' },
    tableWidth: 'auto',
    theme: 'grid',
    headStyles: {
      fillColor: [0, 0, 0],
      textColor: [255, 255, 255],
      fontSize: 10,
      halign: 'center',
    },
    styles: {
      fontSize: 8,
      cellPadding: 1,
      halign: 'center',
      valign: 'middle',
      overflow: 'linebreak',
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      fontSize: 8,
    },
    // Override the default above for the text column
    columnStyles: {
      text: { cellWidth: 'auto' },
      minCellWidth: 60,
    },
  });
  doc.save(`${file}.pdf`);
};

export default {
  downloadExcel,
  downloadPDF,
};
